import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

export type BookingFormProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  text: string
  form: {
    id: number
    fields: any[]
    button: {
      text: string
    }
  }
}

const BookingForm = ({ title, text, form, className, ...props }: BookingFormProps) => {
  return (
    <Section className={cn(className)} {...props}>
      <Container>
        <Grid>
          <div
            className={cn(
              'col-span-2 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4',
              'grid gap-y-spacing-sm md:gap-y-spacing-lg'
            )}
          >
            <div className="grid gap-y-spacing-sm">
              {title ? (
                <div className="flex">
                  <Typography variant="large" component="h2" data-motion-title>
                    {`<b>${title}</b>`}
                  </Typography>
                </div>
              ) : null}

              {text ? (
                <div className="flex">
                  <Typography variant="body" data-motion-paragraph>
                    {text}
                  </Typography>
                </div>
              ) : null}
            </div>

            {form ? (
              <Form form_id={form.id} fields={form.fields} submit={form.button?.text} />
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default BookingForm
